<!-- version 2021/05/20 -->
<template>
  <div class="header-title">
    {{ title }}
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="sass" scoped>
.header-title
  width: 100%
  height: 68px
  line-height: 68px
  font-size: 18px
  font-weight: bold
  align-items: center
  position: absolute
  top: 0
  text-align: center
</style>